import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-input-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, FontAwesomeModule],
  templateUrl: './input-checkbox.component.html',
  styleUrl: './input-checkbox.component.scss'
})
export class InputCheckboxComponent {
  @Input() inputId = ''
  @Input() control = new FormControl()
  @Input() label = ''
  @Input() type = 'text'
  @Input() autocomplete= ''
  @Input() placeholder= ''
  @Input() icon?: IconDefinition

  errorMessages: Record<string, string> = {};

  constructor(private translate: TranslateService) {
    this.loadMessages();
    this.translate.onLangChange.subscribe(() => this.loadMessages());
  }

  private loadMessages(): void {
    this.errorMessages = {
      required: this.translate.instant('validation.required'),
      email: this.translate.instant('validation.email'),
      minlength: this.translate.instant('validation.minlength'),
      notSame: this.translate.instant('validation.notSame'),
      pattern: this.translate.instant('validation.pattern'),
      invalidCardType: this.translate.instant('validation.invalidCardNumber'),
      invalidCardNumber: this.translate.instant('validation.invalidCardNumber'),
      acceptTerms: this.translate.instant('validation.acceptTerms'),
    };
  }
}
